module.exports = __webpack_public_path__ + "img/waves-3.baf03d21.webp";